import { Route } from '@angular/router';

export const killerStatisticsRoutes: Route[] = [
    {
        path: 'killer/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/killer-statistics-details/killer-statistics-details.component').then(
                (c) => c.KillerStatisticsDetailsComponent
            ),
    },
    {
        path: 'killer/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/killer-statistics-games/killer-statistics-games.component').then(
                (c) => c.KillerStatisticsGamesComponent
            ),
    },
    {
        path: 'killer/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/killer-statistics-games-details/killer-statistics-games-details.component').then(
                (c) => c.KillerStatisticsGamesDetailsComponent
            ),
    },
];
